module.exports = __webpack_public_path__ + "img/MES3Area_selection.8f9af19a.png";